import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetTruckHeavyComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <g clipPath="url(#a)">
        <path
          d="M65.41 47.814c-1.088-.631-1.088-2.674 0-4.562s2.857-2.91 3.945-2.283l-3.497-2.023c-1.088-.631-2.856.39-3.945 2.283-1.088 1.888-1.088 3.935 0 4.562z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M65.41 48.296a.5.5 0 0 1-.242-.063l-3.497-2.023c-1.339-.775-1.416-3.068-.178-5.221.776-1.35 1.893-2.327 2.991-2.62.598-.16 1.151-.107 1.614.163l3.497 2.023a.487.487 0 0 1 .178.66.487.487 0 0 1-.66.178c-.236-.135-.534-.159-.881-.067-.843.226-1.763 1.06-2.404 2.172-1.021 1.773-.91 3.478-.178 3.907a.485.485 0 0 1-.246.9zm-.275-9.056c-.126 0-.256.02-.4.058-.843.226-1.763 1.06-2.404 2.172-1.021 1.773-.91 3.483-.178 3.907l1.994 1.151c-.14-1.011.14-2.288.848-3.516.689-1.195 1.647-2.1 2.615-2.495l-1.994-1.152a.94.94 0 0 0-.481-.12z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M65.41 47.814c1.088.631 2.856-.39 3.944-2.283 1.089-1.888 1.089-3.935 0-4.562-1.088-.63-2.856.39-3.945 2.284-1.088 1.888-1.088 3.935 0 4.561"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M66.139 48.484c-.352 0-.68-.082-.968-.25-1.34-.776-1.417-3.07-.178-5.222.775-1.349 1.892-2.327 2.99-2.62.598-.16 1.157-.107 1.614.163 1.34.776 1.417 3.069.179 5.222-.776 1.348-1.893 2.326-2.992 2.62a2.6 2.6 0 0 1-.645.087m-.487-1.089c.236.135.535.16.882.068.843-.227 1.763-1.06 2.404-2.173 1.02-1.773.91-3.478.178-3.906-.236-.135-.535-.16-.882-.063-.843.226-1.763 1.06-2.403 2.172-1.022 1.773-.91 3.478-.179 3.907z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M27.979 69.438c-1.089-.631-1.089-2.674 0-4.562s2.856-2.91 3.945-2.283l-3.497-2.023c-1.089-.631-2.857.39-3.945 2.283-1.09 1.888-1.09 3.936 0 4.562z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M27.978 69.919a.5.5 0 0 1-.241-.063l-3.497-2.023c-1.34-.775-1.417-3.068-.179-5.221.776-1.35 1.893-2.327 2.992-2.62.597-.16 1.15-.107 1.613.158l3.497 2.023a.48.48 0 0 1 .174.66.48.48 0 0 1-.66.174c-.236-.135-.53-.16-.882-.063-.843.226-1.763 1.055-2.403 2.168-1.021 1.767-.91 3.477-.178 3.906a.487.487 0 0 1 .178.66.49.49 0 0 1-.42.24zm-.28-9.056c-.125 0-.255.02-.4.058-.843.226-1.763 1.06-2.403 2.168-1.022 1.772-.91 3.482-.179 3.906l1.99 1.151c-.14-1.011.14-2.288.848-3.516.688-1.195 1.642-2.1 2.615-2.495l-1.994-1.152a.94.94 0 0 0-.482-.12z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M27.978 69.438c1.088.631 2.856-.39 3.945-2.283 1.088-1.888 1.088-3.935 0-4.562-1.089-.63-2.857.39-3.945 2.284-1.089 1.888-1.089 3.935 0 4.561"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M28.7 70.102c-.35 0-.678-.082-.967-.25-1.34-.776-1.416-3.07-.178-5.222.775-1.349 1.893-2.327 2.99-2.62.598-.16 1.152-.107 1.614.163 1.34.776 1.417 3.069.179 5.222-.776 1.349-1.893 2.326-2.992 2.62a2.6 2.6 0 0 1-.645.087m2.496-7.216c-.125 0-.255.02-.4.058-.843.226-1.763 1.055-2.403 2.168-1.022 1.772-.91 3.482-.179 3.906.236.135.53.159.882.063.843-.227 1.763-1.055 2.404-2.168 1.02-1.773.91-3.483.178-3.907a.94.94 0 0 0-.482-.12"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M36.773 64.37c-1.09-.632-1.09-2.674 0-4.563 1.088-1.888 2.856-2.909 3.945-2.283l-3.497-2.023c-1.09-.63-2.857.39-3.945 2.283-1.09 1.889-1.09 3.936 0 4.562z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M36.773 64.851a.5.5 0 0 1-.24-.062l-3.498-2.024c-1.339-.775-1.416-3.068-.178-5.221.776-1.349 1.893-2.327 2.992-2.62.597-.16 1.15-.107 1.613.158l3.497 2.023a.487.487 0 0 1 .179.66.487.487 0 0 1-.66.179c-.236-.135-.535-.16-.882-.068-.843.227-1.763 1.06-2.403 2.173-1.022 1.772-.91 3.477-.179 3.906a.485.485 0 0 1-.246.9zm-.274-9.05q-.186 0-.4.057c-.843.226-1.763 1.06-2.404 2.172-1.02 1.773-.91 3.483-.178 3.907l1.994 1.151c-.14-1.011.14-2.288.848-3.516.689-1.195 1.643-2.1 2.616-2.495l-1.995-1.152a.94.94 0 0 0-.481-.12z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M36.772 64.37c1.088.63 2.856-.39 3.945-2.284 1.088-1.888 1.088-3.935 0-4.561-1.089-.631-2.857.39-3.945 2.283-1.09 1.888-1.09 3.936 0 4.562"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M37.5 65.04c-.352 0-.68-.082-.968-.25-1.34-.776-1.417-3.07-.179-5.223.776-1.348 1.893-2.326 2.992-2.62.597-.159 1.156-.106 1.613.164 1.34.775 1.416 3.068.178 5.221-.775 1.35-1.893 2.327-2.99 2.62a2.6 2.6 0 0 1-.646.088m-.487-1.084c.236.135.535.159.882.067.843-.226 1.763-1.06 2.403-2.172 1.022-1.773.91-3.478.179-3.907-.236-.135-.535-.159-.882-.062-.843.226-1.763 1.06-2.404 2.172-1.02 1.773-.91 3.478-.178 3.907z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M31.4 59.424v1.85c.39.028.76.134 1.088.327.419.24.751.607.987 1.05l1.378-.795c.11-.838.414-1.734.925-2.62 1.064-1.85 2.717-3.04 4.21-3.04q.71.002 1.296.342a2.6 2.6 0 0 1 .977 1.036l21.22-12.245c.11-.843.413-1.753.929-2.644 1.065-1.85 2.717-3.04 4.21-3.04q.709.002 1.296.342c.419.246.751.607.987 1.05l1.643-.949c.453-.265.732-.746.732-1.271v-3.608l-41.893 24.23z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M33.477 63.133a.495.495 0 0 1-.429-.255 2.07 2.07 0 0 0-.804-.858c-.26-.15-.559-.24-.886-.265a.483.483 0 0 1-.448-.482v-1.85c0-.173.091-.332.24-.418l41.894-24.23a.484.484 0 0 1 .723.42v3.607c0 .694-.376 1.344-.974 1.691l-1.642.949a.5.5 0 0 1-.376.048.5.5 0 0 1-.294-.236 2.1 2.1 0 0 0-.804-.862 2.1 2.1 0 0 0-1.055-.275c-1.325 0-2.813 1.099-3.796 2.799-.462.804-.766 1.657-.872 2.466a.49.49 0 0 1-.236.357L42.5 57.984a.476.476 0 0 1-.664-.188 2.07 2.07 0 0 0-.795-.843 2.1 2.1 0 0 0-1.055-.275c-1.325 0-2.813 1.098-3.796 2.799-.458.795-.756 1.642-.867 2.442a.47.47 0 0 1-.236.352l-1.378.794a.5.5 0 0 1-.24.063zm-1.594-2.279A2.943 2.943 0 0 1 33.636 62l.776-.447a7.9 7.9 0 0 1 .949-2.558c1.15-1.994 2.967-3.28 4.629-3.28a2.971 2.971 0 0 1 2.432 1.209l20.622-11.898c.144-.862.472-1.749.954-2.587 1.15-1.994 2.967-3.28 4.629-3.28.553 0 1.074.135 1.536.404q.535.312.91.82l1.243-.719a1 1 0 0 0 .492-.857v-2.775l-40.93 23.671v1.151z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m73.291 35.194-41.888 24.23-.014-.01-14.625-8.454 41.889-24.229z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M31.401 59.904a.5.5 0 0 1-.265-.082l-14.614-8.449a.483.483 0 0 1 0-.838l41.888-24.23a.48.48 0 0 1 .482 0L73.53 34.77a.483.483 0 0 1 0 .838l-41.889 24.23a.5.5 0 0 1-.24.062zM17.726 50.96l13.68 7.91 40.925-23.671-13.675-7.91z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M70.27 16.688 59.6 10.483a5.1 5.1 0 0 0-1.86.627L17.274 34.655a5 5 0 0 1 1.86-.626l10.67 6.204c2.904 3.767 4.836 8.622 4.836 12.876 0 3.27-1.142 5.563-2.982 6.633l40.467-23.546c1.84-1.069 2.982-3.367 2.982-6.633 0-4.253-1.932-9.108-4.836-12.875"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M31.658 60.227a.49.49 0 0 1-.42-.24.48.48 0 0 1 .174-.66c1.768-1.031 2.74-3.237 2.74-6.22 0-4.007-1.748-8.675-4.677-12.509l-10.443-6.074c-.549.091-1.06.275-1.517.544a.48.48 0 0 1-.66-.173.48.48 0 0 1 .173-.66l40.473-23.54a5.6 5.6 0 0 1 2.037-.69.47.47 0 0 1 .308.063l10.67 6.205a.5.5 0 0 1 .14.12c3.092 4.008 4.937 8.935 4.937 13.17 0 3.338-1.142 5.843-3.222 7.052L31.903 60.16a.5.5 0 0 1-.24.067zM19.702 33.802l10.347 6.016a.5.5 0 0 1 .14.12c3.092 4.008 4.937 8.931 4.937 13.17 0 1.816-.337 3.386-.983 4.634l37.741-21.96c1.768-1.032 2.74-3.238 2.74-6.22 0-4.007-1.748-8.675-4.676-12.51L59.504 10.98c-.549.091-1.06.274-1.522.544z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m73.569 22.434-40.43 23.632a21.8 21.8 0 0 1 1.205 4.046l40.448-23.641a21.6 21.6 0 0 0-1.219-4.037z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M34.344 50.594a.486.486 0 0 1-.472-.395 21.3 21.3 0 0 0-1.175-3.955.485.485 0 0 1 .202-.597l40.429-23.632a.47.47 0 0 1 .4-.038c.13.043.236.144.289.274a21.8 21.8 0 0 1 1.247 4.128.48.48 0 0 1-.231.506L34.585 50.527a.5.5 0 0 1-.24.067m-.607-4.32c.395 1.035.713 2.066.94 3.087l39.57-23.131a21 21 0 0 0-.92-3.097z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M31.657 59.746c-1.84 1.07-4.383.915-7.187-.718-5.616-3.266-10.168-11.209-10.168-17.745 0-3.266 1.137-5.56 2.977-6.629a5 5 0 0 1 1.859-.626l10.67 6.204c2.904 3.767 4.836 8.623 4.836 12.876 0 3.27-1.142 5.564-2.982 6.633z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.011 60.912c-1.479 0-3.107-.491-4.783-1.469-5.742-3.338-10.41-11.483-10.41-18.16 0-3.338 1.142-5.838 3.213-7.042a5.5 5.5 0 0 1 2.033-.689.47.47 0 0 1 .308.063l10.67 6.204a.5.5 0 0 1 .14.12c3.092 4.008 4.937 8.93 4.937 13.17 0 3.338-1.146 5.843-3.222 7.052-.863.5-1.836.751-2.886.751M19.035 34.53c-.549.091-1.06.274-1.517.544-1.763 1.026-2.736 3.232-2.736 6.21 0 6.367 4.456 14.142 9.932 17.326 2.558 1.488 4.943 1.744 6.706.718 1.767-1.026 2.74-3.237 2.74-6.22 0-4.007-1.748-8.674-4.677-12.509L19.04 34.525z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M30.414 40.54a.49.49 0 0 1-.42-.24.48.48 0 0 1 .174-.66l37.086-21.58a.48.48 0 0 1 .66.173.48.48 0 0 1-.174.66L30.655 40.478a.5.5 0 0 1-.241.067zM28.853 50.956a.45.45 0 0 1-.241-.067l-3.367-1.96a.48.48 0 0 1-.174-.66.48.48 0 0 1 .66-.174l3.367 1.96a.485.485 0 0 1-.246.9M28.853 48.996a.45.45 0 0 1-.241-.068l-3.367-1.96a.48.48 0 0 1-.174-.66.48.48 0 0 1 .66-.174l3.367 1.96a.485.485 0 0 1-.246.9M28.853 47.04a.45.45 0 0 1-.241-.068l-3.367-1.96a.48.48 0 0 1-.174-.66.48.48 0 0 1 .66-.174l3.367 1.96a.485.485 0 0 1-.246.9"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M5.804 50.66c-.149.068-.515.208-.982.145a1.8 1.8 0 0 1-1.002-.486v-2.866a2.04 2.04 0 0 1 1.984.342z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M5.062 51.306a2 2 0 0 1-.308-.02 2.32 2.32 0 0 1-1.272-.616.48.48 0 0 1-.149-.347v-2.866c0-.202.125-.385.318-.453a2.54 2.54 0 0 1 1.243-.12c.563.087.973.342 1.214.544.11.092.178.227.178.371v2.866a.48.48 0 0 1-.284.439 2.3 2.3 0 0 1-.945.202zm-.766-1.214a1.304 1.304 0 0 0 1.026.222V48.04a1.53 1.53 0 0 0-1.026-.212v2.269z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m31.4 46.233-10.255 5.935c-.452.265-.732 1.271-.732 1.271L5.774 44.971s.28-1.011.733-1.272l10.255-5.934z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M20.413 53.926a.5.5 0 0 1-.241-.063L5.533 45.395a.48.48 0 0 1-.221-.545c.057-.202.36-1.218.958-1.56l10.256-5.935a.48.48 0 0 1 .481 0l14.639 8.469a.484.484 0 0 1 0 .838l-10.255 5.934c-.164.097-.405.598-.51.983a.48.48 0 0 1-.468.351zM6.357 44.759l13.8 7.982c.16-.362.405-.785.752-.988l9.533-5.515-13.676-7.91-10.014 5.795c-.12.068-.275.342-.39.636z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m20.414 53.444-1.368 8.7-14.639-8.47 1.368-8.699z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.045 62.625a.5.5 0 0 1-.241-.063L4.165 54.094a.48.48 0 0 1-.236-.491l1.368-8.7a.48.48 0 0 1 .27-.36.48.48 0 0 1 .448.018l14.639 8.469a.48.48 0 0 1 .236.491l-1.368 8.7a.48.48 0 0 1-.27.36.45.45 0 0 1-.207.049zm-14.114-9.2 13.748 7.948 1.204-7.683-13.748-7.948z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.046 62.142v6.305c0 .569.308 1.026.732 1.272L5.14 61.256a1.45 1.45 0 0 1-.732-1.272v-6.305l14.639 8.468z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.777 70.202a.5.5 0 0 1-.241-.063l-14.64-8.468a1.92 1.92 0 0 1-.972-1.69v-6.306a.484.484 0 0 1 .722-.42l14.64 8.47c.148.086.24.245.24.418v6.306c0 .356.183.679.491.857a.487.487 0 0 1 .179.66.48.48 0 0 1-.42.24zM4.886 54.513v5.467c0 .357.183.68.492.858l13.184 7.625v-6.04z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m19.045 65.645-3.647-2.11v1.864l3.647 2.11z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.045 67.991a.5.5 0 0 1-.24-.063l-3.647-2.11a.48.48 0 0 1-.241-.419v-1.864a.483.483 0 0 1 .723-.419l3.646 2.11c.15.087.24.246.24.42v1.863a.48.48 0 0 1-.24.42.5.5 0 0 1-.24.062M15.88 65.12l2.683 1.551v-.747l-2.683-1.55v.75z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M15.398 65.4v1.786l3.647 2.11V67.51z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M19.045 69.778a.5.5 0 0 1-.24-.063l-3.647-2.11a.48.48 0 0 1-.241-.42V65.4a.483.483 0 0 1 .723-.42l3.646 2.11c.15.087.24.246.24.42v1.787a.48.48 0 0 1-.24.419.5.5 0 0 1-.24.063m-3.165-2.871 2.683 1.555v-.674l-2.683-1.551v.674z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M4.455 60.008c0 .569.308 1.026.737 1.272L8.1 62.961v-1.787l-3.646-2.11v.944"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M8.1 63.449a.5.5 0 0 1-.24-.063L4.95 61.7a1.93 1.93 0 0 1-.977-1.69v-.94a.483.483 0 0 1 .722-.419l3.647 2.11c.149.087.24.245.24.419v1.787a.48.48 0 0 1-.24.42.5.5 0 0 1-.241.062m-3.164-3.546v.106c0 .357.188.675.496.853l2.187 1.267v-.674z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M4.455 57.206v1.864L8.1 61.18v-1.864z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M8.1 61.66a.5.5 0 0 1-.24-.062l-3.647-2.11a.48.48 0 0 1-.24-.419v-1.864a.483.483 0 0 1 .722-.42l3.647 2.11c.149.087.24.246.24.42v1.864a.48.48 0 0 1-.24.419.5.5 0 0 1-.241.063m-3.164-2.87 2.683 1.55v-.746l-2.683-1.551z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="m31.401 46.234-10.255 5.935c-.453.264-.732 1.271-.732 1.271l-1.368 8.7v6.305c0 .568.308 1.026.732 1.272.429.245.978.284 1.47 0l4.807-2.78c.11-.843.414-1.748.93-2.644 1.064-1.85 2.716-3.04 4.21-3.04.072 0 .139.01.206.015z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M20.517 70.405c-.337 0-.67-.087-.973-.265a1.92 1.92 0 0 1-.973-1.69v-6.306q-.001-.035.005-.077l1.368-8.7s.005-.038.01-.052c.057-.203.36-1.22.958-1.561l10.255-5.935a.483.483 0 0 1 .723.42v15.033c0 .135-.058.26-.154.352a.52.52 0 0 1-.362.13h-.067c-.034-.01-.072-.01-.106-.01-1.325 0-2.813 1.099-3.796 2.799-.462.804-.766 1.657-.867 2.466a.49.49 0 0 1-.236.357l-4.807 2.78a1.9 1.9 0 0 1-.973.264zm-.988-8.222v6.267c0 .356.183.679.492.857.308.178.679.178.987 0l4.605-2.664a7.8 7.8 0 0 1 .954-2.582c1.089-1.883 2.77-3.14 4.355-3.27V47.07l-9.533 5.516c-.16.092-.395.578-.506.959l-1.358 8.637z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M29.615 49.73v5.901l-8.246 4.77 1.368-6.692z"
          fill={brandColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M21.367 60.882a.45.45 0 0 1-.28-.091.49.49 0 0 1-.192-.487l1.368-6.69a.5.5 0 0 1 .231-.323l6.879-3.98a.483.483 0 0 1 .723.419v5.902a.48.48 0 0 1-.242.419l-8.241 4.768a.5.5 0 0 1-.241.063zm1.797-6.864-1.108 5.429 7.076-4.09v-4.788z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M23.32 60.79c-.15.067-.516.206-.984.144a1.8 1.8 0 0 1-1.001-.487v-2.866a2.04 2.04 0 0 1 1.984.342z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M22.576 61.43q-.145.002-.304-.019A2.3 2.3 0 0 1 21 60.795a.48.48 0 0 1-.149-.347v-2.866c0-.203.13-.386.318-.453.395-.14.828-.183 1.238-.12.564.086.973.342 1.214.544.11.091.178.226.178.37v2.867a.48.48 0 0 1-.284.438 2.3 2.3 0 0 1-.944.203zm-.766-1.209a1.304 1.304 0 0 0 1.026.222V58.17a1.6 1.6 0 0 0-.578-.212 1.6 1.6 0 0 0-.448 0v2.268z"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M20.366 62.895a.483.483 0 0 1-.482-.482c0-.655.072-.766.631-1.324.29-.29.318-.55.328-.646.02-.188.154-.39.332-.448a.483.483 0 0 1 .626.564q-.087.694-.602 1.209c-.159.159-.322.322-.342.37-.01.03-.01.164-.01.275a.483.483 0 0 1-.481.482"
          fill={color}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <clipPath id="a">
        <path
          d="M3.333 10h72.255v60.405H3.333z"
          fill={fillColor}
          vectorEffect="non-scaling-stroke"
        />
      </clipPath>
    </g>
  </InceptIcon>
);

export const IconAssetTruckHeavy = memo(IconAssetTruckHeavyComponent);
